export default function packingParams(obj) {
  const data = new FormData();
  Object.keys(obj).forEach(key => {
    data.append(key, obj[key]);
  });
  return data;
}
